<template>
  <div>
    <div>
      <div class="block-story" v-if="d.story">&ldquo;{{ d.story }}&rdquo;</div>
      <div class="block-meta name">{{ d.name }}</div>
      <div class="block-meta age" v-if="d.age">Age {{ d.age }}</div>
      <div class="block-meta location" v-if="d.location">{{ d.location }}</div>
      <div v-on:click="openGallery(d.file_name)" class="button first-person-button">{{ d.button_language }}</div>
    </div>
  </div>
</template>

<script>
  module.exports = {
    props: ['d'],
    methods: {
      openGallery: function(image) {
        var imgOverlay = document.querySelector('.art-overlay');
        imgOverlay.classList.toggle("active");
        var notFeatured = document.querySelector(".art-wrapper.active");
        var featured = document.getElementById('featured-'+image);
        var featuredImage = document.getElementById('featured-image'+image);
        if (notFeatured !== null) { notFeatured.classList.remove("active") };
        featuredImage.src = featuredImage.getAttribute("data-src");
        featured.classList.add("active");
      },
    },
  }
</script>

<style scoped></style>
